import $ from "jquery";
export const Accordion = () => {
    $(".accordion").on("click", function(e) {
      if (!$(e.target).is('.main-menu__nav-link')) {
          $(this).toggleClass("active");
          $(this).next().slideToggle(200);
      }
    });
    $(".accordion.desktop").remove();
};